"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressPicker = void 0;
var react_1 = __importStar(require("react"));
var async_creatable_1 = __importDefault(require("react-select/async-creatable"));
var AddressModal_1 = require("./AddressModal");
var PickerStyles_1 = require("./PickerStyles");
var LabelContext_1 = require("../labels/LabelContext");
var GroupContext_1 = require("../layout/GroupContext");
var Debounce_1 = require("./Debounce");
var classnames_1 = __importDefault(require("classnames"));
var PickerStyles_scss_1 = __importDefault(require("./PickerStyles.scss"));
var GoogleLoader_1 = require("./GoogleLoader");
var addressLongNameUse = {
    premise: false,
    street_number: false,
    route: true,
    locality: true,
    administrative_area_level_1: false,
    country: true,
    postal_code: true,
    subpremise: true,
};
var getPlaceAddress = function (placeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, new Promise(function (resolve, reject) {
                var request = {
                    placeId: placeId,
                };
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode(request, function (response, status) {
                    var _a, _b, _c;
                    if (status === google.maps.GeocoderStatus.OK) {
                        if (response) {
                            var data = response;
                            if (!data || data.length == 0) {
                                reject({ status: status });
                            }
                            var details = data[0];
                            var obj = {};
                            for (var p in addressLongNameUse) {
                                for (var _i = 0, _d = details.address_components; _i < _d.length; _i++) {
                                    var component = _d[_i];
                                    if (component.types.indexOf(p) >= 0) {
                                        obj[p] = addressLongNameUse[p] ? component.long_name : component.short_name;
                                    }
                                }
                            }
                            var res = {
                                addressLine1: [obj.premise, obj.subpremise, obj.street_number, obj.route].filter(function (r) { return r && r.length > 0; }).join(' '),
                                suburb: obj.locality || '',
                                state: (_a = obj.administrative_area_level_1) !== null && _a !== void 0 ? _a : '',
                                postCode: (_b = obj.postal_code) !== null && _b !== void 0 ? _b : '',
                                country: (_c = obj.country) !== null && _c !== void 0 ? _c : ''
                            };
                            resolve(res);
                        }
                        else {
                            resolve(null);
                        }
                    }
                    else {
                        reject({ status: status });
                    }
                });
            })];
    });
}); };
var formatAddress = function (value) {
    var temp = [value.suburb, value.state, value.postCode].filter(function (r) { return r && r.length > 0; }).join(' ');
    return [value.addressLine1, temp, value.country].filter(function (r) { return r && r.length > 0; }).join(', ');
};
var AddressPicker = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'block' : _c, props = __rest(_a, ["size"]);
    var _d = (0, react_1.useState)(false), open = _d[0], setOpen = _d[1];
    var _e = (0, react_1.useState)(function () {
        if (props.value) {
            return {
                label: formatAddress(props.value),
                place: null
            };
        }
        else {
            return null;
        }
    }), value = _e[0], setValue = _e[1];
    (0, react_1.useEffect)(function () {
        if (props.value) {
            var label = formatAddress(props.value);
            if (!value || value.label != label) {
                setValue({
                    label: label,
                    place: null
                });
            }
        }
        else if (value) {
            setValue(null);
        }
    }, [props.value]);
    var onSelect = function (v) {
        setValue(v);
        if (v && v.place && v.place.place_id) {
            getPlaceAddress(v.place.place_id).then(function (a) {
                props.onChange && props.onChange(a);
            });
        }
        else {
            props.onChange && props.onChange(null);
        }
    };
    var onSet = function (v) {
        setValue({
            label: formatAddress(v),
            place: null
        });
        props.onChange && props.onChange(v);
    };
    var labelCtx = (0, react_1.useContext)(LabelContext_1.LabelContext);
    var groupCtx = (0, react_1.useContext)(GroupContext_1.GroupContext);
    var state = labelCtx.state || props.state;
    var search = function (s) { return __awaiter(void 0, void 0, void 0, function () {
        var places;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, (0, GoogleLoader_1.loadGoogle)()];
                case 1:
                    places = _a.sent();
                    return [2, new Promise(function (resolve, reject) {
                            var request = {
                                query: s,
                                fields: ["name", "geometry", "formatted_address"],
                            };
                            places.textSearch(request, function (response, status) {
                                if (status === google.maps.places.PlacesServiceStatus.OK) {
                                    if (response) {
                                        var res = response.map(function (place) {
                                            var _a;
                                            return ({
                                                label: (_a = place.formatted_address) !== null && _a !== void 0 ? _a : "",
                                                place: place,
                                            });
                                        });
                                        resolve(res);
                                    }
                                    else {
                                        resolve([]);
                                    }
                                }
                                else {
                                    reject({ status: status });
                                }
                            });
                        })];
            }
        });
    }); };
    var debouncedSearch = (0, react_1.useCallback)((0, Debounce_1.debounce)(search, 1000), []);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)(PickerStyles_scss_1.default["au-picker"], (_b = {},
                _b[PickerStyles_scss_1.default["au-picker--width-".concat(size)]] = size && size != 'block',
                _b[PickerStyles_scss_1.default["au-picker--block"]] = size == 'block',
                _b), groupCtx.className, props.className) },
            react_1.default.createElement(async_creatable_1.default, { inputId: props.id || labelCtx.id, styles: (0, PickerStyles_1.reactSelectStyles)(state), className: (0, classnames_1.default)(groupCtx.className, props.className), placeholder: props.placeholder, loadOptions: debouncedSearch, value: value, onChange: onSelect, getOptionValue: function (r) { return r.label; }, isClearable: true, isDisabled: props.disabled, cacheOptions: false, formatCreateLabel: function () { return "Can't find address? Enter it manually..."; }, onCreateOption: function () { return setOpen(true); } })),
        react_1.default.createElement(AddressModal_1.AddressModal, { id: "".concat(props.id || labelCtx.id, "-modal"), open: open, onClose: function () { return setOpen(false); }, value: { addressLine1: '', country: '', postCode: '', state: '', suburb: '' }, onChange: onSet, countryStates: props.countryStates }));
};
exports.AddressPicker = AddressPicker;
//# sourceMappingURL=AddressPicker.js.map